import { gql } from '@apollo/client';
import { usePaginatedQuery } from '../../../hooks';

export const LIST_DOCUMENT_INSUREDS = gql`
  query insureds(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $ordering: InsuredListOrder
    $status: ExposureStatus
    $searchBy: [InsuredSearchByInput] = []
    $name: String
    $ids: [ID]
    $policyId: ID
    $clientId: ID
    $activeOn: Date
  ) {
    allInsureds(
      first: $first
      after: $after
      last: $last
      before: $before
      ordering: $ordering
      status: $status
      searchBy: $searchBy
      name: $name
      ids: $ids
      policyId: $policyId
      clientId: $clientId
      activeOn: $activeOn
    ) {
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
`;

export default function useListDocumentInsureds({
  onError = () => {},
  onComplete = () => {},
  searchBy,
  filters,
  pageSize = 20
}) {
  const { data, loading, error, paginationProps, queryProps, fetchMore, loadFirstPage } = usePaginatedQuery(
    LIST_DOCUMENT_INSUREDS,
    {
      variables: { searchBy, first: pageSize, ...filters },
      pathToPageInfo: 'allInsureds',
      pageSize,
      onError,
      onComplete
    }
  );

  return {
    insureds: data?.allInsureds?.edges?.map(x => x.node),
    data,
    loading,
    error,
    paginationProps,
    queryProps,
    fetchMore,
    loadFirstPage
  };
}
